import { Stack } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { LaboratoryBrowse, getLaboratoriesOptionsForCenter } from '@/module/Laboratory';
import { ResearchCenterView, getResearchCenterOptions } from '@/module/ResearchCenter';

export const Route = createFileRoute('/_auth/research-center/_research-center/$researchCenterId/_layout/')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
});

function RouteComponent() {
  const { researchCenterId } = Route.useParams();
  const { data: researchCenter } = useSuspenseQuery(getResearchCenterOptions(researchCenterId));

  const { data: labs } = useSuspenseQuery(getLaboratoriesOptionsForCenter(researchCenterId));

  return (
    <Stack gap="xs">
      <ResearchCenterView researchCenter={researchCenter} />

      <LaboratoryBrowse
        researchCenterId={researchCenterId}
        labs={labs}
      />
    </Stack>
  );
}
